import React, { useEffect, useState } from "react";
import axios from "axios";

const BookingForm = ({ doctor, onBack, onSuccess }) => {
  const [schemes, setSchemes] = useState([]);
   const [webreftypes, setWebreftypes] = useState([]);
  const [form, setForm] = useState({
    name: "",
    phone: "",
    email: "",
    schemeid: "",
    webreftypeid: "",
    remarks: "",
  });

  const [errors, setErrors] = useState({});

  /* ==============================
     Load Schemes
  ============================== */
  useEffect(() => {
    axios
      .get("https://nhniapp.in/webapi/spls/splslist1db.php?action=getScheme")
      .then((res) => setSchemes(res.data))
      .catch(() => alert("Failed to load schemes"));
  }, []);

    useEffect(() => {
    axios
      .get("https://nhniapp.in/webapi/spls/splslist1db.php?action=getWebreftype")
      .then((res) => setWebreftypes(res.data))
      .catch(() => alert("Failed to load Webreftype"));
  }, []);

  /* ==============================
     Validation
  ============================== */
  const validate = (name, value) => {
    let error = "";

    if (name === "phone") {
      if (!/^\d{10}$/.test(value)) {
        error = "Phone number must be exactly 10 digits";
      }
    }

    if (name === "email") {
      if (value && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
        error = "Invalid email format";
      }
    }

    return error;
  };

  /* ==============================
     Handle Change
  ============================== */
  const handleChange = (e) => {
    const { name, value } = e.target;

    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));

    setErrors((prev) => ({
      ...prev,
      [name]: validate(name, value),
    }));
  };

  /* ==============================
     Auto-detect Patient by Phone
  ============================== */
  useEffect(() => {
    if (form.phone.length === 10 && !errors.phone) {
      axios
        .get(
          `https://nhniapp.in/webapi/spls/getPatientByPhone.php?phone=${form.phone}`
        )
        .then((res) => {
          if (res.data.status === "found") {
            setForm((prev) => ({
              ...prev,
              name: res.data.patient.name,
              email: res.data.patient.email,
            }));
          }
        })
        .catch(() => {});
    }
  }, [form.phone]);

  /* ==============================
     Form Submit
  ============================== */
  const isFormValid =
    form.name &&
    form.phone &&
    form.schemeid &&
    !errors.phone &&
    !errors.email;

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!isFormValid) return;

    axios
      .post("https://nhniapp.in/webapi/spls/addwebpatient.php", 
        {
    name: form.name,
    phone: form.phone,
    email: form.email,
    schemeid: form.schemeid,
    webreftypeid: form.webreftypeid,
    remarks: form.remarks
  })
      .then(() => {
        alert("Registration successfull");
        onSuccess({
    name: form.name,
    phone: form.phone,
    email: form.email,
    schemeid: form.schemeid,
     webreftypeid: form.webreftypeid,
    remarks: form.remarks
  });

      })
      .catch((err) => {
  console.error(err.response?.data);
  alert(
    err.response?.data?.error ||
    "Server error. Check console & PHP logs."
  );
});
  };

  return (
    <div className="container">
      {/* Header */}
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h4 className="text-primary">Appointment Request for {doctor.title} {doctor.doctorsname}</h4>
        <button className="btn btn-secondary btn-sm" onClick={onBack}>
          ← Back
        </button>
      </div>

      <form onSubmit={handleSubmit} className="card p-4 shadow-sm">
        {/* Row 1 */}
        <div className="row mb-3">
         

          <div className="col-md-6">
            <label>Phone</label>
            <input
              type="text"
              name="phone"
              className={`form-control ${errors.phone ? "is-invalid" : ""}`}
              value={form.phone}
              maxLength="10"
              required
              onChange={handleChange}
              onKeyDown={(e) => {
                if (
                  !/[0-9]/.test(e.key) &&
                  !["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab"].includes(e.key)
                ) {
                  e.preventDefault();
                }
              }}
            />
            {errors.phone && (
              <div className="invalid-feedback">{errors.phone}</div>
            )}
          </div>
           <div className="col-md-6">
            <label>Patient Name</label>
            <input
              type="text"
              name="name"
              className="form-control"
              value={form.name}
              required
              onChange={handleChange}
            />
          </div>
        </div>


        {/* Row 2 */}
        <div className="row mb-3">
          <div className="col-md-6">
            <label>Email</label>
            <input
              type="email"
              name="email"
              className={`form-control ${errors.email ? "is-invalid" : ""}`}
              value={form.email}
              onChange={handleChange}
            />
            {errors.email && (
              <div className="invalid-feedback">{errors.email}</div>
            )}
          </div>

          <div className="col-md-6">
            <label>Scheme</label>
            <select
              name="schemeid"
              className="form-control"
              value={form.schemeid}
              required
              onChange={handleChange}
            >
              <option value="">Select Scheme</option>
              {schemes.map((s) => (
                <option key={s.patschemeid} value={s.patschemeid}>
                  {s.patschemename}
                </option>
              ))}
            </select>
          </div>
        </div>

        {/* Row 3 */}
        <div className="row mb-3">
          <div className="col-md-12">
            <label>How Do You Know about us</label>
            <select
              name="webreftypeid"
              className="form-control"
              value={form.webreftypeid}
              required
              onChange={handleChange}
            >
              <option value="">Select </option>
              {webreftypes.map((s) => (
                <option key={s.webreftypeid} value={s.webreftypeid}>
                  {s.webreftypename}
                </option>
              ))}
            </select>
          </div>
        </div>

        {/* Row 4 */}
        <div className="row mb-3">
          <div className="col-md-12">
            <label>Remarks</label>
            <textarea
              name="remarks"
              className="form-control"
              rows="3"
              value={form.remarks}
              onChange={handleChange}
            />
          </div>
        </div>

        <button
          type="submit"
          className="btn btn-primary w-100"
          disabled={!isFormValid}
        >
          Submit Registration Information
        </button>
      </form>
    </div>
  );
};

export default BookingForm;
